{
  "ui": {
    "feedback": "Feedback",
    "credits": "Credite",
    "currentMaintainer": "Întreținere actuală",
    "maintainerPeriod": "Din 2026",
    "originalTeam": "Echipa originală",
    "creditsCampaigns": "Junglă și Crăciun",
    "moreSettings": "Mai multe setări",
    "chooseLanguage": "Alege limba",
    "notebookTools": "Uneltele caietului",
    "visualGuide": "Ghid în imagini",
    "templeSoon": "În curând",
    "playAdventure": "Joacă",
    "story": "Povestea",
    "loadingAdventure": "Pregătim aventura…",
    "storyOpening": "O excursie școlară în junglă. Marco și Sophia explorează împreună cu prietenii. O pasăre colorată îi atrage atenția lui Marco, iar el o urmează printre copaci. Dintr-odată este singur. Ajută exploratorii să găsească drumul!",
    "storyEnding": "Marco și Sophia ajung împreună la templul pierdut. Un chip misterios păzește intrarea. Îi așteaptă o nouă aventură!",
    "blockCategories": "Filele caietului",
    "actions": "Acțiuni",
    "loops": "Bucle",
    "conditions": "Condiții",
    "title": "Run Marco! — O aventură în caietul tău",
    "home": "Pagina de start Run Marco",
    "map": "Harta aventurii",
    "worlds": "Alege o aventură",
    "notebook": "Caietul meu",
    "notebookToggle": "Deschide sau închide caietul",
    "notebookOpen": "Deschide caietul",
    "notebookClose": "Privește traseul",
    "page": "Pagina {number}",
    "level": "Traseul {number}",
    "run": "Să mergem!",
    "stop": "Oprește",
    "step": "Un pas",
    "stepTitle": "Execută o instrucțiune",
    "reset": "Înapoi la start",
    "add": "Adaugă",
    "addLabel": "Alege un bloc de adăugat",
    "addHint": "Unește blocurile, apoi apasă Joacă.",
    "undo": "Anulează",
    "clear": "Pagină nouă",
    "hint": "Un mic indiciu",
    "help": "Cum se joacă",
    "settings": "Setări",
    "language": "Limba jocului",
    "blockLanguage": "Limba blocurilor",
    "blockLanguageNote": "Poți alege altă limbă pentru blocuri.",
    "musicOn": "Pornește sunetul",
    "musicOff": "Oprește sunetul",
    "sound": "Muzică și efecte sonore",
    "speed": "Viteza aventurii",
    "chooseExplorer": "Alege exploratorul",
    "explorer": "Explorator",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Închide",
    "done": "Să explorăm!",
    "loading": "Căutăm traseul…",
    "loadError": "Aventura nu s-a putut încărca. Reîncarcă pagina pentru a încerca din nou.",
    "imageError": "Unele imagini nu s-au putut încărca. Reîncarcă pagina.",
    "gemGoal": "Găsește nestemata",
    "goal": "Găsește steaua aurie",
    "cover": "Aprinde fiecare pătrățel o singură dată",
    "lit": "Pătrățele aprinse: {count} / {total}",
    "explored": "Trasee explorate: {count} / {total}",
    "facing": "Privește spre {direction} {arrow}",
    "boardLabel": "{name} pe {level}, privește spre {direction}. {steps}. {objective}.",
    "up": "sus",
    "down": "jos",
    "left": "stânga",
    "right": "dreapta",
    "steps_one": "{count} pas",
    "steps_other": "{count} de pași",
    "blocks_one": "{count} bloc",
    "blocks_other": "{count} de blocuri",
    "stars_one": "{count} stea",
    "stars_other": "{count} de stele",
    "place": "Adaugă blocuri",
    "atEnd": "La sfârșit",
    "insideRepeat": "În repetă {number}",
    "insideIf": "În dacă {number}",
    "insideElse": "În altfel {number}",
    "readyFirst": "Un pas mic. Adaugă un bloc înainte și să mergem!",
    "ready": "Unde mergem? Fă un plan în caiet.",
    "back": "Înapoi la start. Blocurile sunt gata pentru o nouă încercare.",
    "empty": "Mai întâi adaugă un bloc în caiet.",
    "win": "Ai găsit drumul!",
    "winCover": "Ai luminat traseul!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Ce aventură!",
    "simpler": "Poți folosi mai puține blocuri?",
    "complete": "Traseu încheiat! Cele mai bune stele sunt salvate.",
    "next": "Traseul următor",
    "allWorlds": "Alte aventuri",
    "replay": "Joacă din nou",
    "shortGoal": "Aproape! Adaugă câteva blocuri ca să ajungi la stea.",
    "shortGem": "Aproape! Adaugă câteva blocuri ca să ajungi la nestemată.",
    "shortCover": "Unele pătrățele sunt încă întunecate. Cum ajungem la ele?",
    "checking": "Privim traseul…",
    "paused": "Pauză. Joacă pornește din nou de la început.",
    "going": "La drum!",
    "stepped": "Cu un pas mai aproape. Apasă Un pas sau Joacă pentru a continua.",
    "clueCover": "Pornește de la o margine și parcurge toată forma. O săritură trece peste un pătrățel fără să-l aprindă.",
    "clueCondition": "Privește drumul din față. O condiție ajută exploratorul să aleagă ce să facă.",
    "clueRepeat": "Ce pași se repetă? Pune acel model într-un bloc de repetare.",
    "clueForward": "Înainte urmează direcția exploratorului. Numără pătrățelele până la stea.",
    "clueGem": "Înainte urmează direcția exploratorului. Numără pătrățelele până la nestemată.",
    "clueTurn": "Rotirea schimbă direcția fără deplasare. Urmărește drumul cu degetul.",
    "mapNote": "Alege un traseu. Cele mai bune stele rămân salvate.",
    "mapLevel": "Traseul {number}: {name}. {stars}.",
    "locked": "Termină traseul anterior pentru a-l debloca pe acesta.",
    "soundBlocked": "Atinge butonul de sunet pentru a auzi aventura.",
    "clearTitle": "Trecem la o pagină nouă?",
    "clearNote": "Blocurile acestui traseu vor fi șterse. Anulează le poate aduce înapoi.",
    "keep": "Păstrează blocurile mele",
    "clearConfirm": "Șterge blocurile",
    "fresh": "O pagină nouă. Unde ne va duce următorul tău plan?",
    "localProgress": "Progresul este salvat pe acest dispozitiv.",
    "helpBuild": "Fă un plan",
    "helpBuildText": "Trage blocuri în caiet și unește-le sau atinge un bloc pentru a-l adăuga. Alege „În repetă” pentru a pune pași într-o buclă.",
    "helpTurn": "Urmează exploratorul",
    "helpTurnText": "Înainte urmează privirea lui. Stânga și dreapta îl rotesc pe loc. Săritura parcurge două pătrățele.",
    "helpTry": "Încearcă, privește, încearcă iar",
    "helpTryText": "Apasă Joacă pentru plan sau Un pas pentru o instrucțiune. Săgeata curbată te întoarce la start și păstrează blocurile.",
    "helpWorlds": "Fiecare aventură are un obiectiv",
    "helpWorldsText": "În Junglă, găsește gema. De Crăciun, luminează fiecare pătrat liber o singură dată. În Templu și în Egee, termină reparațiile și obiectivele afișate, apoi ajungi la ieșire.",
    "noTrail": "Acolo nu este drum! Încearcă să te rotești înainte de a avansa.",
    "broken": "Podul este rupt. Poți sări peste el?",
    "blocked": "Ceva blochează drumul. Încearcă o săritură sau alt traseu.",
    "alreadyLit": "Pătrățelul este deja aprins. Vizitează fiecare pătrățel o singură dată.",
    "loopError": "Planul se repetă fără sfârșit. Încearcă să schimbi bucla.",
    "repeatError": "Alege un număr de repetări de la 1 la 99.",
    "unsupported": "Elimină blocul neacceptat și încearcă din nou.",
    "connect": "Unește blocurile într-un singur șir, apoi apasă Joacă.",
    "path": "drum",
    "steps_few": "{count} pași",
    "blocks_few": "{count} blocuri",
    "stars_few": "{count} stele",
    "backpack": "Rucsac",
    "templeGems": "Nestematele templului",
    "gemsCollected": "Nestemate: {count} / {total}",
    "gemsReady": "Ai adunat toate nestematele!",
    "aegeanTitle": "Misterele Mării Egee",
    "harbour": "Port",
    "aegeanDescription": "Explorează portul: repară stații, refolosește rutine și trimite un număr cu fiecare comandă de lucru.",
    "templeBetaNote": "Beta · Revizuim provocările și lecțiile",
    "aegeanBetaNote": "Beta · Primele 3 niveluri din port",
    "seasonal": "Aventură de sezon",
    "choosePreview": "Alege un nivel de previzualizare",
    "repairs": "Reparații",
    "reachExit": "Ajungi la ieșire",
    "taskRequirements": "Obiectivele misiunii",
    "lessonGuided": "Exercițiu ghidat · completează programul oferit",
    "lessonRepair": "Depanare · corectează programul oferit",
    "lessonChallenge": "Provocare · creează propriul program",
    "acc_define_parameter": "Rutină",
    "acc_call_argument": "Apelează rutina",
    "acc_repeat_parameter": "Repetă folosind intrarea",
    "parameter": "parametru",
    "argument": "trimite",
    "callInput": "Intrarea acestui apel",
    "inputWaiting": "Rulează programul sau execută câte o instrucțiune pentru a vedea următoarea intrare.",
    "argumentMismatch": "O rutină cu parametru necesită un apel cu un număr. Fără parametru, folosește un apel obișnuit.",
    "unsetParameter": "Folosește parametrul numai în rutina care îl primește. Parametrii sunt separați de memoria partajată.",
    "memoryObjective": "Verifică registrul reparațiilor și obiectivele ieșirii. Orice program care le îndeplinește este acceptat.",
    "gate": "Drumul este blocat. Verifică reparațiile neterminate.",
    "noPickup": "Stai pe unealtă înainte să o ridici.",
    "creditLead": "Coordonarea echipei și dezvoltare software",
    "creditArt": "Ilustrație și decoruri",
    "creditAnimation": "Animație",
    "creditUX": "Designul interfeței și al experienței utilizatorului",
    "creditDesign": "Designul jocului",
    "creditStory": "Scrierea poveștii",
    "creditAudio": "Muzică și inginerie de sunet",
    "lightLamp": "Aprinde lampa",
    "oilLamp": "Lampă cu ulei",
    "dustyStation": "stație prăfuită",
    "betaLabel": "Beta",
    "noLamp": "Stai pe o lampă stinsă înainte de a o aprinde.",
    "collected": "Unealtă luată · gata de folosire",
    "dustyPrompt": "Stai pe o stație prăfuită înainte de a folosi pensula.",
    "lampMissing": "Ia mai întâi lampa cu ulei. Uită-te în rucsac.",
    "recursiveRoutine": "Această rutină se apelează singură. Folosește altă rutină; apelurile recursive nu sunt încă disponibile."
  },
  "content": {
    "jungle.title": "Expediție în junglă",
    "jungle.description": "Urmează drumul spre templul pierdut.",
    "jungle-1": "Primii pași",
    "jungle-2": "Puțin mai departe",
    "jungle-3": "După colț",
    "jungle-4": "Schimbă direcția",
    "jungle-5": "Urmează traseul",
    "jungle-6": "Un traseu nou",
    "jungle-7": "Drumuri noi",
    "jungle-8": "Răscruce în junglă",
    "jungle-9": "Găsește drumul",
    "jungle-10": "Gândește în avans",
    "jungle-11": "Traseul lung",
    "jungle-12": "Un drum șerpuit",
    "jungle-13": "Un salt curajos",
    "jungle-14": "Apar modele",
    "jungle-15": "Repetă ritmul",
    "jungle-16": "Alege un drum",
    "jungle-17": "Privește înainte să sari",
    "jungle-18": "Citește traseul",
    "jungle-19": "Un ocol isteț",
    "jungle-20": "Sub coroanele copacilor",
    "jungle-21": "Constructor de poduri",
    "jungle-22": "Dincolo de râu",
    "jungle-23": "Explorează ruinele",
    "jungle-24": "Piatră și lemn",
    "jungle-25": "O săritură mai mare",
    "jungle-26": "Urmează indiciile",
    "jungle-27": "Mai sus",
    "jungle-28": "Continuă explorarea",
    "jungle-29": "Drumuri întortocheate",
    "jungle-30": "Grădina secretă",
    "jungle-31": "Modele ascunse",
    "jungle-32": "Drumuri străvechi",
    "jungle-33": "Ultimele cotituri",
    "jungle-34": "Spre templu",
    "jungle-35": "Aproape am ajuns",
    "jungle-36": "Templul pierdut",
    "winter.title": "Traseul de iarnă",
    "winter.description": "Lasă o lumină în fiecare urmă.",
    "winter-1": "Pași în zăpadă",
    "winter-2": "O altă direcție",
    "winter-3": "Colțuri înghețate",
    "winter-4": "Ocolul lung",
    "winter-5": "Fulg de nea",
    "winter-6": "Bucle de iarnă",
    "winter-7": "Exploratorul gheții",
    "winter-8": "Cotituri și răsuciri",
    "winter-9": "Logică înghețată",
    "winter-10": "Căutător de modele",
    "winter-11": "Maestrul traseului",
    "winter-12": "Minune de iarnă",
    "temple.title": "Templul pierdut",
    "temple.description": "Patruzeci de camere legate: restaurează un instrument ceresc cu unelte, memorie și rutine proprii."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Coș de gunoi gol",
    "OPEN_TRASH": "Deschide coșul de gunoi",
    "BLOCK_LABEL_BEGIN_STACK": "Început de șir",
    "WORKSPACE_LABEL_1_STACK": "1 șir de blocuri",
    "WORKSPACE_LABEL_MANY_STACKS": "Șiruri de blocuri: %1",
    "ARIA_TYPE_FIELD_NUMBER": "număr",
    "ARIA_TYPE_FIELD_DROPDOWN": "listă derulantă",
    "ARIA_TYPE_FIELD_IMAGE": "imagine",
    "WORKSPACE_LABEL_PLAIN": "Caietul meu",
    "FIELD_LABEL_EDIT_PREFIX": "Editează %1",
    "BLOCK_LABEL_HAS_INPUT": "are o intrare",
    "BLOCK_LABEL_HAS_INPUTS": "are intrări",
    "BLOCK_LABEL_HAS_BRANCHES": "ramuri: %1",
    "FIELD_LABEL_OPTION_INDEX": "Opțiunea %1",
    "INPUT_LABEL_EMPTY": "Gol",
    "BLOCK_LABEL_DISABLED": "dezactivat",
    "BLOCK_LABEL_COLLAPSED": "restrâns",
    "BLOCK_LABEL_BEGIN_PREFIX": "Început: %1",
    "INPUT_LABEL_END_STATEMENT": "Sfârșit: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "text",
    "ARIA_TYPE_FIELD_INPUT": "intrare",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "numele intrării",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "numele rutinei"
  }
}
